import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSdCard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSdCard"><Path d="M17.5 2.5H4.5V21.5H19.5V11L17.5 7.75V2.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M9.5 6.5V9.5" stroke="currentColor" strokeLinecap="square"/><Path d="M12.5 6.5V9.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSdCard;
